<template>
    <div class="container-fluid">
        <div class="row">
            <div class="col-md-12">
                <div class="row">
                        <div class="col-md-3">
                            <div class="card left_filter_card_bg">
                                <div class="card-body">
                                    <div class="form-group">
                                        <label class="title_label">Category</label>
                                        <select class="form-control" v-model="select_cat" @change="getEvents()"  name="category"  id="category">
                                            <option selected="true" disabled="disabled" value=null>Select Category</option>
                                            <option v-for="items in category" :key="items.id" :value="items.id"> {{ items.name }}</option>
                                        </select>
                                    </div>


                                </div>
                            </div>
                        </div>
                    <div class="col-md-9"  id="product_list">
                       
                        <div v-if="results.length == 0">
                              <span class="text-center text-center ml-auto mr-auto"> <b>There Is No Conserve Activities ! </b></span>
                        </div>
                        <div v-else>
                            <div class="row">
                                <blog-card v-for="item in results"  :key="item.id" :item="item"></blog-card>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: "BlogList",
    data() {
        return {
            results: [],
            category:[],
            select_cat:null
        };
    },
    created() {
        this.getEvents();

    },

    methods: {
            getEvents(){


            var url='/api/conserve/blogs/data';

                axios.post(url, {'category': this.select_cat})
                .then(response => {
                    console.log(response);
                      this.category = response.data.category;
                      this.results = response.data.conserve;
                })
                .catch(error => {
                    console.log(error);
                });
            },


    }
}
</script>
